import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter } from '../../../global/commonStyle';

const DeleteWarning = styled.h6`
  ${Typography.body_md}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const Buttons = styled.div`
  ${AlignCenter}
  justify-content: flex-end;
  margin: var(--space-0);
  gap: var(--space-12);
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
  padding: var(--space-16);
`;

export { DeleteWarning, Buttons, ModalContent };
